import * as api from '../api';
// Static JS-based override for constant countries to keep runtime code JS-only and maintainable.
import { options as __constCountryOptions, CountryMeta as __CountryMeta, show as __COUNTRIES_SHOW } from '../constants/countries.override';

// Lightweight memoization to avoid repeated calls (e.g., StrictMode double effects)
let __countriesCache = null;
const __countryByIdCache = new Map();

export const getActors = async () => {
    try {
        const {data} = await api.getActors();
        return data;
    } catch(error) {
        console.log(error)
    }
}
export const getCountries = async () => {
    try {
        if (__countriesCache) return __countriesCache;
        const {data} = await api.getCountries();
        let merged = Array.isArray(data) ? data.slice() : [];
        try {
            if (__COUNTRIES_SHOW) {
                const constOpts = typeof __constCountryOptions === 'function' ? __constCountryOptions() : (__constCountryOptions || []);
                const constCountries = (Array.isArray(constOpts) ? constOpts : []).map(opt => {
                    const meta = (__CountryMeta && __CountryMeta[opt.code]) || {};
                    const labels = meta.labels || {};
                    return {
                        id: opt.id,
                        name: opt.label,
                        label_fr: labels.french ?? opt.label,
                        label_en: labels.english ?? opt.label,
                        label_pr: labels.portugais ?? opt.label,
                        label_sw: labels.swahili ?? opt.label,
                        isPrincipal: false,
                        code: opt.code
                    };
                });

                const existingIds = new Set(merged.map(c => String(c.id)));
                for (const cc of constCountries) {
                    if (!existingIds.has(String(cc.id))) merged.push(cc);
                }
            }
        } catch (e) {
            console.error('Failed to merge constant countries from override module', e);
        }

        __countriesCache = merged;
        return merged;
    } catch(error) {
        console.log(error)
    }
}


export const readCountry = async (id = undefined) => {
    try {
        const key = String(id || 'default');
        if (__countryByIdCache.has(key)) return __countryByIdCache.get(key);
        const {data} = await api.readCountry(id);
        __countryByIdCache.set(key, data);
        return data;
    } catch(error) {
        console.log(error)
    }
}
export const listNews = async () => {
    try {
        const {data} = await api.listNews();
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const listSlide = async () => {
    try {
        const {data} = await api.listSlides();
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const listDashInd = async () => {
    try {
        const {data} = await api.listDashInd();
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const listIndi = async () => {
    try {
        const {data} = await api.listIndicator();
        return data;
    } catch(error) {
        console.log(error)
    }
}


export const readNew = async (id) => {
    try {
        const {data} = await api.readNew(id);
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const readLastDetB = async () => {
    try {
        const {data} = await api.readLastDetBalance();
        return data;
    } catch(error) {
        console.log(error)
    }
}


export const readDetB = async (year, country) => {
    try {
        const {data} = await api.readDetBalance(year, country);
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const readSimpB = async (year, country) => {
    try {
        const {data} = await api.readSimpleBalance(year, country);
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const readCombfgazm = async (year, country) => {
    try {
        const {data} = await api.readCombfgazmStat(year, country);
        return data;
    } catch(error) {
        console.log(error)
    }
}
export const readElecq = async (year, country) => {
    try {
        const {data} = await api.readElecqstatStat(year, country);
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const readEnrbiomasse = async (year, country) => {
    try {
        const {data} = await api.readEnrbiomasseStat(year, country);
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const readGaznatural = async (year, country) => {
    try {
        const {data} = await api.readGaznaturalStat(year, country);
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const readPetrole = async (year, country) => {
    try {
        const {data} = await api.readPetrolestat(year, country);
        return data;
    } catch(error) {
        console.log(error)
    }
}
export const readDashboard = async (dashboard, country) => {
    try {
        const {data} = await api.readDashboardstat(dashboard, country);
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const readDashboardCompare = async (dashboard) => {
    try {
        const {data} = await api.readDashboardCompareStat(dashboard);
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const readIndicator = async (indicator, country) => {
    try {
        const {data} = await api.readIndicatorStat(indicator, country);
        return data;
    } catch(error) {
        console.log(error)
    }
}
export const postContact = async ({name, email, subject, message}) => {
    try {
        const {data} = await api.sendContact({name, email, subject, message});
        return data;
    } catch(error) {
        console.log(error)
    }
};


export const homeDashboard = async (countryId = undefined) => {
    try {
        const {data} = await api.hDashboardStat(countryId);
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const getIndicatorKey = async (countryId = undefined) => {
    try {
        const {data} = await api.indicatorKey(countryId);
        return data;
    } catch(error) {
        console.log(error)
    }
}


export const getFactor = async (toUnit) => {
    try {
        const {data} = await api.getFactor(toUnit);
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const getFlow = async () => {
    try {
        const {data} = await api.getFlow();
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const getFlowActiveYear = async () => {
    try {
        const {data} = await api.getFlowActiveYear();
        return data;
    } catch(error) {
        console.log(error)
    }
}

export const getFlowByYear = async ($flow, $year) => {
    try {
        const {data} = await api.getFlowByYear($flow, $year);
        return data;
    } catch(error) {
        console.log(error)
    }
}





/*export const setTokenLog = async () => {
    try {
        return await api.setTokenLogin();
    } catch(error) {
        console.log(error)
    }
}*/

export const getPublishedSankeys = async() => {
    try {
        const { data } = await api.listPublishedSankeys();
        return data;
    } catch (error) {
        console.log(error)
    }
}

export const getSankeyDetails = async(id, year=null, country=null) => {
    try {
        const { data } = await api.readSankey(id, year, country);
        return data;
    } catch (error) {
        console.log(error)
    }
}
export const getSankeyYears = async(id) => {
    try {
        const { data } = await api.readSankeyYears(id);
        return data;
    } catch (error) {
        console.log(error)
    }
}
